import { render, staticRenderFns } from "./TableCustomerListDetails.vue?vue&type=template&id=6905d372&scoped=true"
import script from "./TableCustomerListDetails.vue?vue&type=script&lang=js"
export * from "./TableCustomerListDetails.vue?vue&type=script&lang=js"
import style0 from "./TableCustomerListDetails.vue?vue&type=style&index=0&id=6905d372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6905d372",
  null
  
)

export default component.exports